import { apiV2 } from "../v2";
import {
  getAdminGeneratorLogsRequest,
  getAdminGeneratorLogsResponse,
  getAdminGeneratorResponse,
  putAdminGeneratorHostRequest,
  putAdminGeneratorSwitchRequest,
} from "./generator.dto";

export const getAdminGeneratorApi = apiV2("GET", "/admin/generator").withResponse(getAdminGeneratorResponse);

export const putAdminGeneratorHostApi = apiV2("PUT", "/admin/generator/host").withRequest(putAdminGeneratorHostRequest).withResponse(getAdminGeneratorResponse);

export const putAdminGeneratorSwitchApi = apiV2("PUT", "/admin/generator/switches")
  .withRequest(putAdminGeneratorSwitchRequest)
  .withResponse(getAdminGeneratorResponse);

export const getAdminGeneratorLogsApi = apiV2("GET", "/admin/generator/logs")
  .withRequest(getAdminGeneratorLogsRequest)
  .withResponse(getAdminGeneratorLogsResponse);
